import React from 'react';

/**
 * SignatureElement - Independent signature placeholder component
 * The actual SignaturePad component is portaled in during document completion
 * This component renders the placeholder during design time
 */
const SignatureElement = ({ element, mode = 'form' }) => {
  const { content } = element;
  const {
    label = 'Digital Signature',
    name = 'signature',
    required = true,
    instructionText = '',
    legalNoticeText = ''
  } = content || {};

  return (
    <div className="form-field form-signature-field" style={{ width: '100%', boxSizing: 'border-box' }}>
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="form-required"> *</span>}
        </label>
      )}
      <div
        className="form-signature-pad"
        data-signature-field={name}
        data-instruction-text={instructionText}
        data-legal-notice-text={legalNoticeText}
      >
        <div className="signature-placeholder">
          <span className="signature-icon">✍️</span>
          <p>Click here to sign digitally</p>
          <small>Your signature will be securely captured and embedded in the document</small>
        </div>
      </div>
    </div>
  );
};

export default SignatureElement;
